import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VehicleImage } from "./vehicle-image";
import styles from "./vehicle-card-v2.module.css";
import cx from "classnames";
import { penceToPounds } from "@cinch-labs/shared-util";
import { Tags } from "./tags";
import { Price } from "./price";
import { AdminFee } from "./admin-fee";
import { CompareAndFavouriteBar } from "./compare-and-favourite-bar";
export var VehicleCardV2 = function(param) {
    var vehicle = param.vehicle;
    var make = vehicle.make, model = vehicle.model, thumbnailUrl = vehicle.thumbnailUrl, isAvailable = vehicle.isAvailable, variant = vehicle.variant, isReserved = vehicle.isReserved, fuelType = vehicle.fuelType, transmissionType = vehicle.transmissionType, mileage = vehicle.mileage, modelYear = vehicle.modelYear, vehicleYear = vehicle.vehicleYear, price = vehicle.price, discountInPence = vehicle.discountInPence;
    var makeModel = "".concat(make, " ").concat(model);
    var isCarOnOffer = !!discountInPence;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(VehicleImage, {
                isAvailable: isAvailable,
                src: thumbnailUrl,
                alt: makeModel
            }),
            isReserved && isAvailable && /*#__PURE__*/ _jsx("span", {
                className: cx(styles.badge, styles.reserved),
                children: "Reserved"
            }),
            isCarOnOffer && !isReserved && isAvailable && /*#__PURE__*/ _jsx("span", {
                className: cx(styles.badge, styles.discount),
                children: "".concat(penceToPounds(discountInPence !== null && discountInPence !== void 0 ? discountInPence : 0), " off")
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: styles.title,
                                children: makeModel
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.subtitle,
                                children: variant
                            }),
                            /*#__PURE__*/ _jsx(Tags, {
                                fuelType: fuelType,
                                transmissionType: transmissionType,
                                mileage: mileage,
                                year: Number(vehicleYear || modelYear)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Price, {
                                price: price,
                                discountInPence: discountInPence || 0
                            }),
                            /*#__PURE__*/ _jsx(AdminFee, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CompareAndFavouriteBar, {
                vehicle: vehicle
            })
        ]
    });
};
